import {
  errorForConfig,
  StoryblokAPI4xx,
  StoryblokAPI5xx,
  LandingPagesAPIError,
  BrandPagesAPI4xx,
} from '../../utils/errors';

export const isEmptyObject = (obj) =>
  Object.entries(obj).length === 0 && obj.constructor === Object;

// combines the statusForState functionality of both Storyblok landing pages and
// cuisine landing pages, to provide a single source of truth for the
// success/failure of requesting a given landing page under `/cuisines`, given
// this may be either an existing CLP or a Storyblok page, and we can’t know up
// front which.
export const statusForState = ({ config, cuisine = {}, brands: brand = {}, landingPage = {} }) => {
  const configError = errorForConfig(config);
  const landingPageError = landingPage.error || {};
  const cuisineError = cuisine.error || {};
  const brandError = brand.error || {};

  switch (true) {
    case configError:
      // there was an error requesting the config endpoint, i.e. before we even get
      // to Storyblok.
      return {
        status: 500,
        configError,
      };
    case landingPageError.status === 404 && isEmptyObject(cuisine) && isEmptyObject(brand):
      // no landing page exists for the requested route, so it’s probably a 404
      // against a non-existent story
      return {
        status: 404,
        error: new StoryblokAPI4xx(`Storyblok API Error: ${JSON.stringify(landingPageError)}`),
      };
    case landingPageError.status !== undefined && isEmptyObject(cuisine) && isEmptyObject(brand):
      return {
        status: 500,
        error: new StoryblokAPI5xx(
          `Landing Pages API Error: (${landingPageError.status}) ${landingPageError.message}`,
        ),
      };
    case cuisineError.status === 200:
      // since the mark-landingpages GraphQL endpoint will always return a 200
      // status code, even for non-existent cuisines, these need to be massaged
      // into a 404 to correctly capture the error
      return {
        status: 404,
        error: new LandingPagesAPIError(`Landing Pages API Error: ${JSON.stringify(cuisineError)}`),
      };
    case cuisineError.status !== undefined:
      return {
        status: 500,
        error: new LandingPagesAPIError(
          `Landing Pages API Error: Cuisine (${cuisineError.status}) ${cuisineError.message}`,
        ),
      };
    case !landingPage.name && brandError.status === 404:
      return {
        status: 404,
        error: new BrandPagesAPI4xx(
          `Brand Pages API Error: (${brandError.status}) ${brandError.message}`,
        ),
      };
    case !landingPage.name && !cuisine.cuisine && !brand.current:
      // neither a landing page nor a cuisine was returned in the response, so
      // it’s definitely a 404… but why wouldn’t this be captured by
      // cuisineError.status: 200? Needs verifying to see if we can ever end up
      // here.
      return { status: 404 };
    default: {
      switch (true) {
        case Boolean(landingPage.name):
          return { status: 200, page: 'landing-page' };
        case !isEmptyObject(brand):
          return { status: 200, page: 'brand' };
        default:
          return { status: 200, page: 'cuisines' };
      }
    }
  }
};

export const getLandingPagePath = (request) => {
  const { path } = request.currentQuery;
  return `/${path}`;
};
